import { frensMixin } from "@mixin/frens";
export default {
  name: "pageFrens",
  mixins: [frensMixin]
};